import { take, takeLatest } from "redux-saga/effects";
import { Creators as AllCreators, Types as AllTypes } from "../../actions";
import {
  fetchLocalAuthentication,
  handleFetchLocalAuthenticationSuccess,
  handleLoginSuccess,
  login,
  logout,
} from "../../actions/authentication";

const Creators = (AllCreators as any).App;
const Types = (AllTypes as any)._APP;

export function* watchFetchLocalAuthentication() {
  yield takeLatest(
    Types.FETCH_LOCAL_AUTHENTICATION,
    fetchLocalAuthentication({
      onSuccess: Creators.handleFetchLocalAuthenticationSuccess,
    })
  );
}

export function* watchHandleFetchLocalAuthenticationSuccess() {
  yield takeLatest(Types.HANDLE_FETCH_LOCAL_AUTHENTICATION_SUCCESS, handleFetchLocalAuthenticationSuccess({}));
}

export function* watchLogin() {
  yield takeLatest(
    Types.LOGIN,
    login({
      onFailure: Creators.handleLoginFailure,
      onSuccess: Creators.handleLoginSuccess,
    })
  );
}

export function* watchHandleLoginSuccess() {
  yield takeLatest(Types.HANDLE_LOGIN_SUCCESS, handleLoginSuccess({}));
}
export function* watchLogout() {
  yield takeLatest(Types.LOGOUT, logout({ onSuccess: Creators.handleLogoutSuccess }));
}

export function* watchMount() {
  yield take(Types.MOUNT);
}

export function* watchUnmount() {
  yield take(Types.UNMOUNT);
}
